import { DeleteImportBulkInput, DeleteImportBulkResponse, DeleteImportInput } from '@/models/gen/graphql';

import { DeleteImportBulkDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

const [, runRefetchDeleteImportBulk] = graphApi(DeleteImportBulkDocument);

const deleteImportBulk = async (importIds: string[]): Promise<DeleteImportBulkResponse> => {
  const search: DeleteImportInput[] = importIds.map((id: string): DeleteImportInput => ({ id }));
  const input: DeleteImportBulkInput = {
    search,
  };

  const res = await runRefetchDeleteImportBulk({ input });
  return res?.deleteImportBulk;
};

export const useDeleteImportBulk = createGraphApiHook(deleteImportBulk);

export default deleteImportBulk;
